// extracted by mini-css-extract-plugin
export default {"titleContent":"styles_titleContent__HFpMx"};